import script from "./LandingPageXL.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingPageXL.vue?vue&type=script&setup=true&lang=js"

import "./LandingPageXL.vue?vue&type=style&index=0&id=675b5881&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-675b5881"]])

export default __exports__